export default __webpack_public_path__ + "static/media/ch_box.eaa65371.svg";